import React from 'react';
import { WorkstationHub } from '@/components/zones/WorkstationHub';
import { useOrdersManagement } from '@/hooks/useOrdersManagement';
import { useAuth } from '@/components/auth/AuthProvider';

export const Orders = () => {
  const { user } = useAuth();
  const isAuthReady = !!user;
  const { orders, ordersLoading: isLoading } = useOrdersManagement(true, isAuthReady);
  
  return <WorkstationHub orders={orders} isLoading={isLoading} />;
};